import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import LocationSearchBar from "../../commonComponents/navBar/locationSearchBar";
import "../../commonComponents/navBar/navBar.scss";
import "./userProfile.scss";
import { useForm } from "react-hook-form";
import jwt_decode from "jwt-decode";
import bcrypt from "bcryptjs";
import checkExistence from "../../commonComponents/check-existence/checkExistence";

function UserProfile() {
  const token = localStorage.getItem("token");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const password = useRef({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [emailExistence, setEmailExistence] = useState("");
  const [showPasswordInputs, setShowPasswordInputs] = useState(false);
  const [inputsActiveName, setInputsActiveName] = useState(false);
  const [inputsActiveEmail, setInputsActiveEmail] = useState(false);
  const [inputsActivePhone, setInputsActivePhone] = useState(false);
  const [userData, setUserData] = useState(null);
  const locationSelected = useSelector((state) => state.userReducer);
  const nameInput = document.getElementById("name_surname");
  const emailInput = document.getElementById("email");
  const phoneInput = document.getElementById("phone");
  const passwordInput = document.getElementById("password");
  const passwordConfirmationInput = document.getElementById(
    "passwordConfirmation"
  );

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    fetch("https://femez.onrender.com/API/user/userProfile", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          return res.json();
        } else {
          throw new Error(`Request failed with status: ${res.status}`);
        }
      })
      .then((data) => {
        setUserData(data);
        console.log(data);
        const decodedToken = jwt_decode(token);
        dispatch({
          type: "HANDLECHANGE",
          payload: {
            location: decodedToken.address,
          },
        });
        setValue("name_surname", data.name_surname);
        setValue("email", data.email);
        setValue("phone", data.phone);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const editProfile = (elementToUpdate) => {
    switch (elementToUpdate) {
      case "nameElement":
        setInputsActiveName(!inputsActiveName);
        break;
      case "emailElement":
        setInputsActiveEmail(!inputsActiveEmail);
        break;
      case "phoneElement":
        setInputsActivePhone(!inputsActivePhone);
        break;
      case "passwordElement":
        setShowPasswordInputs(!showPasswordInputs);
        break;
    }
  };

  password.current = watch("password", "");
  const updateUserData = async () => {
    if (
      (locationSelected.address.label === userData.address ||
        locationSelected.address.label === "") &&
      nameInput.value === userData.name_surname &&
      emailInput.value === userData.email &&
      phoneInput.value === userData.phone &&
      ((showPasswordInputs &&
        passwordConfirmationInput.value === "" &&
        passwordInput.value === "") ||
        !showPasswordInputs)
    ) {
      setErrorMessage("You havent done any changes on your profile");
      setSuccessMessage("");
    } else {
      setErrorMessage("");
      setSuccessMessage("");
      let hashedPassword;
      if (showPasswordInputs) {
        const saltRounds = 10;
        hashedPassword = bcrypt.hashSync(passwordInput.value, saltRounds);
      }
      await fetch("https://femez.onrender.com/API/user/userProfileEditing", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          updatedAddress: locationSelected.address,
          full_name: nameInput.value,
          updatedEmail: emailInput.value,
          updatedPhone: phoneInput.value,
          updatedPassword: hashedPassword,
          showPasswordInputs: showPasswordInputs,
        }),
      })
        .then((res) => {
          if (res.status === 200) {
            setSuccessMessage("Updated successfully");
            return res.json();
          } else {
            return res.json().then((data) => {
              // throw new Error(data.message);
              const error = new Error(data.message);
              error.response = res; // Attach the response to the error for further inspection if needed
              throw error;
            });
          }
        })
        .then((data) => {
          dispatch({
            type: "HANDLECHANGE",
            payload: {
              location: locationSelected.address,
            },
          });
          if (data) {
            fetch("https://femez.onrender.com/API/user/refreshToken", {
              method: "GET",
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
              .then((res) => {
                if (res.status === 200) {
                  return res.json();
                } else {
                  throw new Error(`Request failed with status: ${res.status}`);
                }
              })
              .then((dataAddress) => {
                localStorage.setItem("token", dataAddress.token);
              })
              .catch((err) => {
                console.error(err);
              });
          }
        })
        .catch((err) => {
          setErrorMessage(err.message);
          if (err.message === "429") {
            setErrorMessage(
              "You have exceeded the number of the updates per a day"
            );
          }
        });
    }
  };

  const validateExistence = async (value) => {
    if (value !== userData.email) {
      await checkExistence(
        value,
        "https://femez.onrender.com/API/user/users/",
        setEmailExistence
      );
      if (emailExistence !== "") {
        return emailExistence;
      } else {
        return true;
      }
    }
    return true; // Return true if the value is empty
  };

  useEffect(() => {
    const timeoutId = setTimeout(async () => {
      const emailValueInput = watch("email");
      const result = await validateExistence(emailValueInput);
      if (result !== true) {
        trigger("email"); // Trigger validation for the email field
      }
    }, 500);

    // Clear the timeout if the component unmounts or if the email input changes
    return () => clearTimeout(timeoutId);
  }, [watch, trigger]);

  const DeleteAccount = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete your account?"
    );
    if (isConfirmed) {
      await fetch(`https://femez.onrender.com/API/user/DeleteAccount`, {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => {
          // Check if the response status is OK (200)
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.text();
        })
        .then((data) => {
          localStorage.removeItem("token");
          navigate(`/`);
          console.log(data);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    }
  };

  return (
    <div className="container-profile">
      <form onSubmit={handleSubmit(updateUserData)}>
        <div className="profile">
          <div className="profile-elements-location">
            <label>Location</label>
            <LocationSearchBar autofocusProp={false} />
          </div>
          <div className="profile-elements">
            <label>Full Name</label>
            <input
              id="name_surname"
              type="text"
              {...register("name_surname", {
                required: "This field is required",
                pattern: {
                  value: /^[A-Za-z\-_\s]+$/i,
                  message: "The name must contain alphabetic characters only",
                },
                validate: (value) =>
                  value.trim().length > 0 || "The name-surname cannot be empty",
                minLength: {
                  value: 4,
                  message:
                    "The length of the name-surname must be greater than or equal to 4 characters",
                },
                maxLength: {
                  value: 50,
                  message:
                    "The length of the name-surname must be less than or equal to 50 characters",
                },
              })}
              readOnly={!inputsActiveName}
              className={inputsActiveName ? "active" : "inactive"}
            />

            {errors.name_surname && (
              <span className="error_span">{errors.name_surname.message}</span>
            )}

            <div
              className="edit-profile-button"
              onClick={() => editProfile("nameElement")}
            >
              Edit name
            </div>
          </div>
          <div className="profile-elements">
            <label>Email</label>
            <input
              {...register("email", {
                required: "This field is required",
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Invalid email address",
                },
                validate: validateExistence,
              })}
              type="email"
              id="email"
              readOnly={!inputsActiveEmail}
              className={inputsActiveEmail ? "active" : "inactive"}
            />
            {errors.email && (
              <span className="error_span">{errors.email.message}</span>
            )}
            <div
              className="edit-profile-button"
              onClick={() => editProfile("emailElement")}
            >
              Edit email
            </div>
          </div>
          <div className="profile-elements">
            <label>Phone Number</label>
            <input
              {...register("phone", {
                required: "This field is required",
                pattern: {
                  value: /^[?\d+]+$/i,
                  message: "Invalid phone number",
                },
              })}
              id="phone"
              type="tel"
              readOnly={!inputsActivePhone}
              className={inputsActivePhone ? "active" : "inactive"}
            />
            {errors.phone && (
              <span className="error_span">{errors.phone.message}</span>
            )}
            <div
              className="edit-profile-button"
              onClick={() => editProfile("phoneElement")}
            >
              Edit phone
            </div>
          </div>
          <div className="password-element">
            <div
              className="edit-profile-button"
              onClick={() => editProfile("passwordElement")}
            >
              Change my password
            </div>
            {showPasswordInputs && (
              <div className="password-div-container">
                <div>
                  <label>Create New Password</label>
                  <input
                    {...register("password", {
                      required: "This field is required",
                      pattern: {
                        value: /^(?=.*[A-Za-z])(?=.*[0-9])(?=.{8,})/,
                        message:
                          " The password must contain at least (1 character, 1 number, length greater or equal 8 character)",
                      },
                    })}
                    id="password"
                    type="password"
                  />
                </div>
                {errors.password && (
                  <span className="error_span">{errors.password.message}</span>
                )}
                <div>
                  <label>Confirm New Password</label>
                  <input
                    {...register("passwordConfirmation", {
                      required: "This field is required",
                      validate: (value) => {
                        if (value === password.current) {
                          return true; // Validation passed
                        } else {
                          return "Password confirmation does not match"; // Custom error message
                        }
                      },
                    })}
                    id="passwordConfirmation"
                    type="password"
                  />
                </div>
              </div>
            )}

            {errors.passwordConfirmation && (
              <span className="error_span">
                {errors.passwordConfirmation.message}
              </span>
            )}
          </div>

          <div>
            <span style={{ color: "red" }}>{errorMessage}</span>
            <span style={{ color: "green" }}>{successMessage}</span>
            <input
              type="submit"
              value="Update"
              className="updateButton"
              id="submit"
            />
          </div>
          <div className="edit-profile-button" onClick={() => DeleteAccount()}>
            Delete my account
          </div>
        </div>
      </form>
    </div>
  );
}

export default UserProfile;
